var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"70"}}),_c('p',{staticClass:"text-caption pt-3"},[_vm._v(" Authenticating... ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }